import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import {
    Button,
    Col,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Form,
    FormGroup,
    Input,
    Label,
    Row,
    UncontrolledDropdown,
    Modal,
    ModalHeader,
    ModalBody,
    Container,
} from 'reactstrap';
import { PlusCircle, MoreVertical } from 'react-feather';
import axios from 'axios';
import Swal from 'sweetalert2';
import moment from 'moment';
import { baseURL, getPublicS3Url } from '../../../../Services/api/baseURL';
import Loader from '../../../Loader/Loader';
import { FaPen, FaTrashAlt } from 'react-icons/fa';

const ServiceTable = () => {
    const [services, setServices] = useState({
        data: [],
        loading: false,
        totalRows: 0,
        perPage: 10,
        currentPage: 1
    });

    const [searchTerm, setSearchTerm] = useState('');
    const [modal, setModal] = useState({
        isOpen: false,
        type: 'add',
        selectedService: null
    });

    const [formData, setFormData] = useState({
        name: "",
        description: "",
        image: null,
        imagePreview: "",
        sections: []
    });

    const token = localStorage.getItem('token') ? JSON.parse(localStorage.getItem('token')) : null;
    console.log(token, "token from local storage")
    const userRole = localStorage.getItem('role_name') ? JSON.parse(localStorage.getItem('role_name')) : null;

    // Fetch Services
    const fetchServices = async () => {
        setServices(prev => ({ ...prev, loading: true }));
        try {
            const response = await axios.get(`${baseURL}/api/service`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            const formattedData = response.data?.data || response.data;

            setServices(prev => ({
                ...prev,
                data: formattedData,
                loading: false,
                totalRows: formattedData.length,
            }));
        } catch (error) {
            setServices(prev => ({ ...prev, loading: false }));
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.response?.data?.message || 'Failed to fetch services'
            });
        }
    };

    useEffect(() => {
        if (token) fetchServices();
    }, [token]);

    const openModal = (type, service = null) => {
        setModal({ isOpen: true, type, selectedService: service });

        if (service) {
            setFormData({
                name: service?.name || "",
                description: service?.description || "",
                image: service?.image,
                imagePreview: service?.image ? getPublicS3Url(service?.image) : "",
                sections: service?.sections.map(sec => ({
                    subHeading: sec.subHeading,
                    subDescription: sec.subDescription,
                    images: sec.images,
                    imagePreviews: sec.images.map(img => getPublicS3Url(img)),
                })) || []
            });
        } else {
            resetForm();
        }
    };

    const closeModal = () => {
        setModal({ isOpen: false, type: "add", selectedService: null });
        resetForm();
    };

    const resetForm = () => {
        setFormData({
            name: "",
            description: "",
            image: null,
            imagePreview: "",
            sections: []
        });
    };

    // Section handling
    const addSection = () => {
        setFormData(prev => ({
            ...prev,
            sections: [...prev.sections, { subHeading: "", subDescription: "", images: [], imagePreviews: [] }]
        }));
    };

    const updateSection = (index, field, value) => {
        const newSections = [...formData.sections];
        newSections[index][field] = value;
        setFormData(prev => ({ ...prev, sections: newSections }));
    };

    const handleSectionImageChange = (index, files) => {
        const newSections = [...formData.sections];

        // Append new files to existing images
        const existingFiles = newSections[index].images || [];
        const existingPreviews = newSections[index].imagePreviews || [];

        const newFiles = Array.from(files);
        const newPreviews = newFiles.map(file => URL.createObjectURL(file));

        newSections[index].images = [...existingFiles, ...newFiles];
        newSections[index].imagePreviews = [...existingPreviews, ...newPreviews];

        setFormData(prev => ({ ...prev, sections: newSections }));
    };


    const removeSection = (index) => {
        const newSections = [...formData.sections];
        newSections.splice(index, 1);
        setFormData(prev => ({ ...prev, sections: newSections }));
    };

    const handleRemoveSectionImage = (sectionIdx, imageIdx) => {
        console.log(sectionIdx, imageIdx)
        const newSections = [...formData.sections];
        console.log(newSections[sectionIdx])
        console.log(newSections[sectionIdx].images)
        newSections[sectionIdx].images = newSections[sectionIdx].images.filter(
            (_, i) => i !== imageIdx
        );
        newSections[sectionIdx].imagePreviews = newSections[sectionIdx].imagePreviews.filter(
            (_, i) => i !== imageIdx
        );
        setFormData(prev => ({ ...prev, sections: newSections }));
    };


    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            const preview = URL.createObjectURL(file);
            setFormData(prev => ({
                ...prev,
                image: file,
                imagePreview: preview
            }));
        }
    };

    // Submit service (upload files)
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.name?.trim()) {
            Swal.fire({ icon: "warning", title: "Missing Name", text: "Service name is required." });
            return;
        }

        if (!formData.imagePreview) {
            Swal.fire({ icon: "warning", title: "Missing Image", text: "Service image is required." });
            return;
        }

        try {
            const data = new FormData();
            data.append("name", formData?.name);
            data.append("description", formData?.description || "");
            // data.append("sections", JSON.stringify(formData?.sections));

            if (formData.image instanceof File) {
                data.append("image", formData.image);
            }

            formData.sections.forEach((section, idx) => {
                // Append section metadata (without actual files)
                data.append(
                    `sections[${idx}]`,
                    JSON.stringify({
                        subHeading: section.subHeading,
                        subDescription: section.subDescription,
                        images: section.images.filter(img => typeof img === 'string') // only existing URLs
                    })
                );

                // Append new files separately
                section.images
                    .filter(img => img instanceof File) 
                    .forEach(file => {
                        data.append(`sections[${idx}][images]`, file);
                    });
            });

            console.log(formData, "formdata")
            console.log(data, "before hitting submit API")
            // return;
            const endpoint =
                modal.type === "add"
                    ? `${baseURL}/api/service`
                    : `${baseURL}/api/service/${modal.selectedService._id}`;
            const method = modal.type === "add" ? "post" : "put";

            await axios[method](endpoint, data, {
                headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" }
            });

            Swal.fire({
                icon: "success",
                title: modal.type === "add" ? "Service Added!" : "Service Updated!",
                text: `${formData.name} has been ${modal.type === "add" ? "added" : "updated"}.`,
            });

            closeModal();
            fetchServices(services.currentPage);
        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: error.response?.data?.message || "Failed to submit service",
            });
        }
    };

    // Delete service
    const handleDeleteService = async () => {
        try {
            await axios.delete(`${baseURL}/api/service/${modal.selectedService._id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            Swal.fire({
                icon: 'success',
                title: 'Service Deleted',
                showConfirmButton: false,
                timer: 1500
            });

            closeModal();
            fetchServices(services.currentPage);
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.response?.data?.message || 'Failed to delete service'
            });
        }
    };

    const columns = [
        {
            name: 'Image',
            selector: row => row.image,
            center: true,
            cell: row => row.image
                ? <img src={getPublicS3Url(row.image)} alt={row.name} style={{ width: '60px', height: '60px', objectFit: 'cover', borderRadius: '6px' }} />
                : 'No Image'
        },
        { name: 'Service Name', selector: row => row.name, sortable: true },
        { name: 'Description', sortable: false, wrap: true, cell: row => <div className="line-clamp-1 max-w-xs text-sm text-gray-700" title={row.description} style={{ cursor: 'pointer' }}>{row.description}</div> },
        { name: 'Created Date', selector: row => moment(row.createdAt).format('DD/MM/YYYY'), sortable: true, center: true },
        {
            name: "Actions",
            cell: (row) => (
                <div className="d-flex justify-content-end align-items-center">
                    <UncontrolledDropdown className="action_dropdown">
                        <DropdownToggle className="action_btn">
                            <MoreVertical color="#000" size={16} />
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem onClick={() => openModal('edit', row)}>
                                Update <FaPen />
                            </DropdownItem>
                            <DropdownItem className="delete_item" onClick={() => openModal('delete', row)}>
                                Delete <FaTrashAlt />
                            </DropdownItem>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </div>
            ),
            right: true,
        },
    ];

    const filteredServices = (services.data || []).filter(item =>
        String(item?.name || "").toLowerCase().includes(String(searchTerm || "").toLowerCase())
    );

    return (
        <div>
            <Row className="mb-3">
                <Col className="d-flex justify-content-between align-items-center">
                    <h4>Services</h4>
                    <div className="d-flex align-items-center">
                        <input
                            type="text"
                            className="form-control me-2"
                            placeholder="Search services..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{ width: '200px' }}
                        />
                        {userRole === 'admin' && (
                            <Button className='btn btn-primary d-flex align-items-center' onClick={() => openModal('add')}>
                                <PlusCircle size={16} className="me-1" /> Add Service
                            </Button>
                        )}
                    </div>
                </Col>
            </Row>

            <DataTable
                columns={columns}
                data={filteredServices}
                progressPending={services.loading}
                progressComponent={<Loader />}
                pagination
                paginationPerPage={services.perPage}
                paginationRowsPerPageOptions={[10, 20, 50, 100]}
                onChangeRowsPerPage={(newPerPage) => setServices(prev => ({ ...prev, perPage: newPerPage }))}
            />

            {/* Add/Edit Modal */}
            <Modal centered isOpen={modal.isOpen && ["add", "edit"].includes(modal.type)} toggle={closeModal} size="lg">
                <ModalHeader toggle={closeModal}>{modal.type === "add" ? "Add Service" : "Edit Service"}</ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleSubmit}>
                        <FormGroup>
                            <Label>Service Name <span className="text-danger">*</span></Label>
                            <Input type="text" value={formData.name} onChange={(e) => setFormData(prev => ({ ...prev, name: e.target.value }))} required />
                        </FormGroup>

                        <FormGroup>
                            <Label>Description</Label>
                            <Input type="textarea" rows="4" value={formData.description} onChange={(e) => setFormData(prev => ({ ...prev, description: e.target.value }))} />
                        </FormGroup>

                        <FormGroup>
                            <Label>Image <span className="text-danger">*</span></Label>
                            <div className="mb-2" style={{ display: 'flex', gap: '8px' }}>
                                <Input 
                                    type="text" 
                                    placeholder={modal.type === "add" ? "Select image file..." : "Click to change image..."}
                                    value={
                                        formData.image?.name 
                                            ? formData.image.name 
                                            : (modal.type === "edit" && formData.image && !formData.image.name 
                                                ? formData.image.split('/').pop() 
                                                : "")
                                    }
                                    readOnly
                                    style={{ flex: 1, backgroundColor: '#f5f5f5' }}
                                />
                                <Button 
                                    type="button" 
                                    color="primary" 
                                    onClick={() => document.getElementById('serviceImageInput').click()}
                                    style={{ whiteSpace: 'nowrap' }}
                                >
                                    Browse
                                </Button>
                                {formData.image && (
                                    <Button 
                                        type="button" 
                                        color="danger" 
                                        onClick={() => setFormData(prev => ({ ...prev, image: null, imagePreview: "" }))}
                                        style={{ whiteSpace: 'nowrap' }}
                                    >
                                        Clear
                                    </Button>
                                )}
                            </div>
                            <Input 
                                id="serviceImageInput"
                                type="file" 
                                accept="image/*" 
                                onChange={handleImageUpload} 
                                required={modal.type === "add"} 
                                style={{ display: 'none' }}
                            />
                            {formData.imagePreview && (
                                <div 
                                    className="mt-2" 
                                    style={{
                                        position: "relative",
                                        width: "120px",
                                        height: "120px",
                                        borderRadius: "8px",
                                        overflow: "hidden",
                                    }}
                                >
                                    <button
                                        type="button"
                                        onClick={() => setFormData(prev => ({ ...prev, image: null, imagePreview: "" }))}
                                        style={{
                                            position: "absolute",
                                            top: "4px",
                                            right: "4px",
                                            background: "rgba(254, 0, 0, 0.8)",
                                            color: "white",
                                            border: "none",
                                            borderRadius: "50%",
                                            width: "24px",
                                            height: "24px",
                                            fontSize: "16px",
                                            cursor: "pointer",
                                            padding: "0",
                                            zIndex: 1,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        ×
                                    </button>
                                    <img 
                                        src={formData.imagePreview} 
                                        alt="Preview" 
                                        style={{ 
                                            width: "100%", 
                                            height: "100%", 
                                            objectFit: "cover",
                                            borderRadius: "8px" 
                                        }} 
                                    />
                                </div>
                            )}
                        </FormGroup>

                        <hr />
                        <Row className="mb-3">
                            <Col className="d-flex justify-content-between align-items-center">
                                <h5>Sections</h5>
                                <Button type="button" onClick={addSection}>+ Add Section</Button>
                            </Col>
                        </Row>

                        {formData.sections.map((section, idx) => (
                            <div key={idx} className="border p-2 mb-2 rounded">
                                <Row>
                                    <Col md={6}>
                                        <Label>Sub Heading</Label>
                                        <Input type="text" value={section.subHeading} onChange={(e) => updateSection(idx, "subHeading", e.target.value)} required />
                                    </Col>
                                    <Col md={6}>
                                        <Label>Sub Description</Label>
                                        <Input type="text" value={section.subDescription} onChange={(e) => updateSection(idx, "subDescription", e.target.value)} />
                                    </Col>
                                </Row>
                                <FormGroup className="mt-2">
                                    <Label>Images</Label>
                                    <Input type="file" multiple accept="image/*" onChange={(e) => handleSectionImageChange(idx, e.target.files)} />
                                    <div className="d-flex mt-2 gap-2 flex-wrap">
                                        {section.imagePreviews.map((img, i) => (<div
                                            key={i}
                                            style={{
                                                position: "relative",
                                                width: "60px",
                                                height: "60px",
                                                borderRadius: "6px",
                                                overflow: "hidden",
                                            }}
                                        >
                                            {/* ❌ Cross icon */}
                                            <button
                                                type="button"
                                                onClick={() => handleRemoveSectionImage(idx, i)}
                                                style={{
                                                    position: "absolute",
                                                    top: "-6px",
                                                    right: "-6px",
                                                    background: "rgba(254, 0, 0, 0.6)",
                                                    color: "white",
                                                    border: "none",
                                                    borderRadius: "50%",
                                                    width: "20px",
                                                    height: "20px",
                                                    fontSize: "12px",
                                                    cursor: "pointer",
                                                    padding: "2px",
                                                    zIndex: 1,
                                                }}
                                            >
                                                ×
                                            </button>

                                            <img
                                                src={img}
                                                alt="preview"
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                    borderRadius: "6px",
                                                }}
                                            />
                                        </div>))}
                                    </div>
                                </FormGroup>
                                <Button color="danger" size="sm" onClick={() => removeSection(idx)}>Remove Section</Button>
                            </div>
                        ))}

                        <Row className="text-center p-2 mt-3">
                            <Button type="submit">{modal.type === "add" ? "Add Service" : "Update Service"}</Button>
                        </Row>
                    </Form>
                </ModalBody>
            </Modal>

            {/* Delete Modal */}
            <Modal centered isOpen={modal.isOpen && modal.type === 'delete'} toggle={closeModal}>
                <ModalHeader toggle={closeModal}>Delete Service</ModalHeader>
                <Container className="text-center mb-4">
                    <h5>Are you sure you want to delete service <span className='font-danger'>{modal?.selectedService?.name}</span>?</h5>
                    <p className="text-danger">This action cannot be undone.</p>
                    <Row className="text-center">
                        <Col xs={6}>
                            <Button className="btn btn-secondary w-100" onClick={closeModal}>Cancel</Button>
                        </Col>
                        <Col xs={6}>
                            <button type="button" className="btn btn-red w-100" onClick={handleDeleteService} style={{ backgroundColor: '#dc3545', color: '#fff' }} disabled={services.loading}>Confirm Delete</button>
                        </Col>
                    </Row>
                </Container>
            </Modal>
        </div>
    );
};

export default ServiceTable;
